import React from 'react';

import InstructionStep from './InstructionStep';
import InstructionStepType from './types';

import './InstructionSteps.scss';

interface InstructionStepsProps {
    instructionSteps: InstructionStepType[];
}

const InstructionSteps = ({ instructionSteps }: InstructionStepsProps) => (
    <section className="instruction-steps">
        {instructionSteps.map(({ icon, text }) => (
            <InstructionStep key={icon} icon={icon} text={text} />
        ))}
    </section>
);

export default InstructionSteps;
